<template>
  <div>
    <div class="columns">
      <div class="column is-2">
        <h1 class="title is-4">Planillas</h1>
      </div>
      <div class="column">
        <div class="buttons">
          <div class="button is-link" @click="viewform()">
            <span class="icon is-small">
              <span class="material-icons"> post_add </span>
            </span>
            <span>Crear Planilla</span>
          </div>
        </div>
      </div>
    </div>
    <div class="notification" v-show="showform">
      <h1 class="title is-4">Nueva planilla de nómina</h1>
      <h1 class="title is-6">Seleccione el periodo</h1>
      <y-periodselector
        @period="periodselected"
        :iscierre="false"
        :period="period"
      ></y-periodselector>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">Periodicidad</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="planilla.periodicity">
                  <option :value="null">Seleccionar</option>
                  <option :value="1">Semanal</option>
                  <option :value="2">Decenal</option>
                  <option :value="3">Catorcenal</option>
                  <option :value="4">Quincenal</option>
                  <option :value="5">Mensual</option>
                  <option :value="6">Otro</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">Nombre</label>
            <div class="control">
              <input
                v-model="planilla.name"
                class="input"
                type="text"
                placeholder="Nombre de la planilla"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="buttons">
        <button class="button is-link" @click="save">Guardar</button>
        <button class="button" @click="cancel">Cancelar</button>
      </div>
    </div>

    <table class="table">
      <thead>
        <tr>
          <th>Año</th>
          <th>Mes</th>
          <th>Periodicidad</th>
          <th>Nombre</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in planillas" :key="index">
          <td>{{ item.year }}</td>
          <td>{{ nmonth[item.month] }}</td>
          <td>{{ per[item.periodicity] ? per[item.periodicity] : "" }}</td>
          <td>{{ item.name }}</td>
          <th>
            <div class="buttons">
              <button class="button is-info" @click="edit(item)">
                <span class="icon is-small">
                  <span class="material-icons">edit </span>
                </span>
                <span>Editar</span>
              </button>
              <router-link
                :to="{
                  name: 'planillanomina.detalle',
                  params: {
                    planillaid: item._id,
                  },
                }"
                class="button is-dark"
              >
                <span class="icon">
                  <i class="material-icons">check_circle_outline</i>
                </span>
                <span>Seleccionar</span>
              </router-link>
              <button class="button">
                <span class="icon is-small">
                  <span class="material-icons">content_copy </span>
                </span>
                <span>Copiar</span>
              </button>
            </div>
          </th>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import yPeriodselector from "@/components/commons/PeriodselectorV2.vue";
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      nmonth: {
        1: "Enero",
        2: "Febrero",
        3: "Marzo",
        4: "Abril",
        5: "Mayo",
        6: "Junio",
        7: "Julio",
        8: "Agosto",
        9: "Septiembre",
        10: "Octubre",
        11: "Noviembre",
        12: "Diciembre",
      },
      per: {
        1: "Semanal",
        2: "Decanal",
        3: "Catorcenal",
        4: "Quincenal",
        5: "Mensual",
        6: "Otro",
      },
      showform: false,
      planilla: {
        _id: null,
        year: null,
        month: null,
        periodicity: null,
        name: null,
      },
      period: {
        year: null,
        months: [0],
      },
      planillas: [],
    };
  },
  methods: {
    edit(d) {
      this.planilla = d;
      this.period.year = d.year;
      this.period.months = [d.month];
      console.log(this.period.months);
      this.showform = true;
    },
    async save() {
      try {
        this.planilla.year = this.period.year;
        this.planilla.month = this.period.months[0];
        if (!this.planilla.periodicity) {
          this.$store.dispatch("notify", {
            message: "Debe indicar una periodicidad.",
            type: "is-danger",
            position: "top-center",
          });
          return false;
        }
        if (!this.planilla.name) {
          this.$store.dispatch("notify", {
            message: "La planilla debe tener un nombre.",
            type: "is-danger",
            position: "top-center",
          });
          return false;
        }
        let result;
        if (this.planilla._id) {
          result = await apiServices.post(`/edittitleplanillanomina`, {
            planilla: this.planilla,
          });
        } else {
          result = await apiServices.post(`/savetitleplanillanomina`, {
            planilla: this.planilla,
          });
        }
        if (result.data) {
          this.$store.dispatch("notify", {
            message: "Planilla guardada con éxito.",
            position: "top-center",
          });
          this.cancel();
          this.findPlanillas();
        }
      } catch (err) {
        console.log(err);
      }
    },
    viewform() {
      if (this.showform) {
        this.showform = false;
      } else {
        this.showform = true;
      }
    },
    periodselected(period) {
      this.period = period;
    },
    async findPlanillas() {
      try {
        const result = await apiServices.get(`/titleplanillas`);
        if (result.data) {
          this.planillas = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    cancel() {
      this.planilla = {
        _id: null,
        year: null,
        month: null,
        periodicity: null,
        name: null,
      };
      this.showform = false;
    },
  },
  created() {
    const today = new Date();
    this.period.year = today.getFullYear();
    this.period.months = [today.getMonth() + 1];
    this.findPlanillas();
  },
  components: {
    yPeriodselector,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/nomina/planilla/Creaplanilla.vue